import { ACCESS_LEVEL_VIEW } from "../../../../constants";

export default ({ customerAccess, isProductInStock, isVariantInStock }) =>
  customerAccess !== ACCESS_LEVEL_VIEW &&
  (!isProductInStock || (isProductInStock && isVariantInStock === false));
